import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LightsOut.css';

const LightsOut = () => {
  const [board, setBoard] = useState(() => generateRandomBoard());
  const [moves, setMoves] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  function generateRandomBoard() {
    // Start with all lights off
    const board = Array(5).fill().map(() => Array(5).fill(false));
    
    // Randomly click some positions to create a solvable puzzle
    const numClicks = Math.floor(Math.random() * 10) + 5;
    for (let i = 0; i < numClicks; i++) {
      const row = Math.floor(Math.random() * 5);
      const col = Math.floor(Math.random() * 5);
      toggleLights(board, row, col);
    }
    
    return board;
  }

  function toggleLights(board, row, col) {
    const directions = [
      [0, 0],   // center
      [-1, 0],  // up
      [1, 0],   // down
      [0, -1],  // left
      [0, 1]    // right
    ];

    directions.forEach(([dr, dc]) => {
      const newRow = row + dr;
      const newCol = col + dc;
      
      if (newRow >= 0 && newRow < 5 && newCol >= 0 && newCol < 5) {
        board[newRow][newCol] = !board[newRow][newCol];
      }
    });
  }

  const handleCellClick = (row, col) => {
    if (isComplete) return;

    const newBoard = board.map(r => [...r]);
    toggleLights(newBoard, row, col);
    setBoard(newBoard);
    setMoves(prev => prev + 1);

    // Check if all lights are off (puzzle solved)
    const allOff = newBoard.every(row => row.every(cell => !cell));
    if (allOff) {
      setIsComplete(true);
    }
  };

  const resetGame = () => {
    setBoard(generateRandomBoard());
    setMoves(0);
    setIsComplete(false);
  };

  const newEasyGame = () => {
    // Generate an easier puzzle with fewer initial moves
    const board = Array(5).fill().map(() => Array(5).fill(false));
    const numClicks = Math.floor(Math.random() * 5) + 2;
    for (let i = 0; i < numClicks; i++) {
      const row = Math.floor(Math.random() * 5);
      const col = Math.floor(Math.random() * 5);
      toggleLights(board, row, col);
    }
    setBoard(board);
    setMoves(0);
    setIsComplete(false);
  };

  const newHardGame = () => {
    // Generate a harder puzzle with more initial moves
    const board = Array(5).fill().map(() => Array(5).fill(false));
    const numClicks = Math.floor(Math.random() * 15) + 10;
    for (let i = 0; i < numClicks; i++) {
      const row = Math.floor(Math.random() * 5);
      const col = Math.floor(Math.random() * 5);
      toggleLights(board, row, col);
    }
    setBoard(board);
    setMoves(0);
    setIsComplete(false);
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">💡 Lights Out</h1>
        <div className="game-instructions">
          Click a light to toggle it and its adjacent lights. Turn off all lights to win!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          {isComplete ? '🎉 All Lights Out!' : `Moves: ${moves}`}
        </div>

        <div className="game-play-area">
          <div className="lights-out-board">
            {board.map((row, rowIndex) =>
              row.map((isOn, colIndex) => (
                <div
                  key={`${rowIndex}-${colIndex}`}
                  className={`light-cell ${isOn ? 'on' : 'off'}`}
                  onClick={() => handleCellClick(rowIndex, colIndex)}
                >
                  <div className="light-bulb">
                    {isOn ? '💡' : '⚫'}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="difficulty-buttons">
          <button onClick={newEasyGame} className="btn btn-success">
            Easy
          </button>
          <button onClick={resetGame} className="btn btn-primary">
            Normal
          </button>
          <button onClick={newHardGame} className="btn btn-danger">
            Hard
          </button>
        </div>
      </div>

      <div className="game-controls">
        <button className="btn btn-primary" onClick={resetGame}>
          Reset Game
        </button>
        <Link to="/" className="btn btn-secondary">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default LightsOut;